module.exports = __webpack_public_path__ + "static/media/icon-coin.6bfddcbb.png";